<div class="deal-details-wrapper">

  <div>

    <div class="deal-details-row">
      <h2 class="mb-0">
        Details
      </h2>
    </div>

    <div class="deal-details-row" *ngIf="approvals?.length > 0">
      <h4 class="mb-0">Position</h4>
      <div>
        {{ approvals[0].position || '' }}
      </div>
    </div>

    <div class="deal-details-row">
      <h4 class="mb-0">Product Name</h4>
      <div>
        {{ deal.loan_product.name || '' }}
      </div>
    </div>

    <div class="deal-details-row">
      <h4 class="mb-0">Product ID</h4>
      <div>
        {{ deal.loan_product.id || '' }}
      </div>
    </div>

    <div *ngIf="sbaStatus" class="deal-details-row">
      <h4 class="mb-0">SBA Status</h4>
      <div>
        {{ sbaStatus || 'N/A' }}
      </div>
      <mat-icon *ngIf="sbaStatusTooltipText !== ''" class="deal-details-sbastatus-tooltip"
                matTooltip="{{sbaStatusTooltipText}}"
                matTooltipPosition="right">
        info_outline
      </mat-icon>
    </div>

    <div class="deal-details-row">
      <h4 class="mb-0">Deal ID</h4>
      <div>
        {{ deal.id }}
      </div>
    </div>

  </div>

</div>
